function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M57.0729 14.7342L55.1731 12.8211C54.5751 12.2237 53.7796 11.8945 52.9294 11.8945C52.0797 11.8945 51.2833 12.2237 50.6853 12.8211L29.013 34.4945L7.3156 12.7971C6.71862 12.1996 5.92218 11.871 5.07245 11.871C4.22272 11.871 3.4258 12.1996 2.82835 12.7971L0.928008 14.6984C-0.309336 15.9348 -0.309336 17.9488 0.928008 19.1852L26.7613 45.1114C27.3583 45.7084 28.1538 46.129 29.0111 46.129H29.021C29.8712 46.129 30.6667 45.7079 31.2637 45.1114L57.0729 19.2554C57.6709 18.6584 57.9991 17.8389 58 16.9892C58 16.139 57.6709 15.3307 57.0729 14.7342Z",
  fill: "black"
});

function SvgReportDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportDownArrow);
export default __webpack_public_path__ + "static/media/report-down-arrow.95679529.svg";
export { ForwardRef as ReactComponent };